
import {getProList, getProDetail} from '../../services/api'
import utils from '../../utils/utils'

const project = {
  state: {
    proList: [],
    proDetail: {}
  },
  mutations: {
    setProList (state, data) {
      state.proList = data;
    },
    setProDetail (state, data) {
      state.proDetail = data;
    }
  },
  actions: {
    ajaxProList ({ commit }, data) {
      var params = data;
      return new Promise((resolve, reject) => {
        getProList(params).then((response) => {
          var result = response.data;
          if(result.status == 1){
            result.data.forEach(element => {
              var tempTime = new Date();
              tempTime.setTime(element.time);
              element.time = utils.timeFormat(tempTime, 'yyyy年MM月dd日');
              return element;
            });
            commit('setProList', result.data);
            resolve(result.totalCount);
          }
        }).catch((error) => {
          reject(error);
        });
      })
    },
    ajaxProDetail ({ commit }, data) {
      var params = data;
      return new Promise((resolve, reject) => {
        getProDetail(params).then((response) => {
          var result = response.data;
          if(result.status == 1){
            commit('setProDetail', result.data);
            resolve(result.data);
          }
        }).catch((error) => {
          reject(error);
        });
      })
    }
  },
  getters: {
    
  }
}

export default project